import { consumeImportEvents } from './bulkUserImportService';
import { BULK_IMPORT_COMPLETED } from '../userEventKinds';

const jsonOk = (body) => ({ ok: true, json: async () => body });

const events = (...list) => jsonOk({ events: list });

const markReadCall = () =>
  global.fetch.mock.calls.find(
    ([url]) => url === '/management/user_events/mark_read.json',
  );

afterEach(() => {
  delete global.fetch;
});

describe('management/Users bulkUserImportService', () => {
  describe('consumeImportEvents', () => {
    it('marks only the events for the given import read', async () => {
      global.fetch = jest
        .fn()
        .mockResolvedValueOnce(
          events(
            { id: 1, kind: BULK_IMPORT_COMPLETED, subjectId: 42 },
            { id: 2, kind: BULK_IMPORT_COMPLETED, subjectId: 43 },
            { id: 3, kind: BULK_IMPORT_COMPLETED, subjectId: 42 },
          ),
        )
        .mockResolvedValueOnce(jsonOk({}));

      await consumeImportEvents(42);

      expect(JSON.parse(markReadCall()[1].body)).toEqual({ ids: [1, 3] });
    });

    // The wizard has the id from a JSON body, the event carries it from another;
    // one arriving as a string must not silently leave the toast unconsumed.
    it('matches the subject id across types', async () => {
      global.fetch = jest
        .fn()
        .mockResolvedValueOnce(
          events({ id: 9, kind: BULK_IMPORT_COMPLETED, subjectId: 42 }),
        )
        .mockResolvedValueOnce(jsonOk({}));

      await consumeImportEvents('42');

      expect(JSON.parse(markReadCall()[1].body)).toEqual({ ids: [9] });
    });

    it('leaves other imports alone rather than clearing everything unread', async () => {
      global.fetch = jest
        .fn()
        .mockResolvedValueOnce(
          events({ id: 1, kind: BULK_IMPORT_COMPLETED, subjectId: 99 }),
        );

      await consumeImportEvents(42);

      expect(markReadCall()).toBeUndefined();
    });

    // Losing the consume costs a duplicate toast. Failing the summary the admin
    // is trying to read costs a great deal more.
    it('does not reject when the request fails', async () => {
      global.fetch = jest.fn().mockResolvedValue({ ok: false, status: 500 });

      await expect(consumeImportEvents(42)).resolves.toBeUndefined();
    });
  });
});
